import React, { FC, ReactNode } from 'react';
import failureCard from 'assets/failure_card.svg';
import warningCard from 'assets/warning_card.png';

const MESSAGE_TYPES: Record<
  string,
  {
    icon: string;
    defaultTitle: string;
    className: string;
    alt: string;
  }
> = {
  error: {
    icon: failureCard,
    defaultTitle: 'Failed to pay',
    className: 'failure-message',
    alt: 'Failure card',
  },
  warning: {
    icon: warningCard,
    defaultTitle: 'Warning',
    className: 'failure-message warning-message',
    alt: 'Warning',
  },
};

interface PaymentErrorProps {
  title?: string;
  errorMessage: string;
  type?: keyof typeof MESSAGE_TYPES;
  children?: ReactNode;
}

const PaymentError: FC<PaymentErrorProps> = ({ title, errorMessage, type = 'error', children }) => {
  const messageProps = MESSAGE_TYPES[type] || MESSAGE_TYPES.error;
  return (
    <div className={messageProps.className}>
      <img src={messageProps.icon} alt={messageProps.alt} />
      <div>
        <h6>{title || messageProps.defaultTitle}</h6>
        <span>{errorMessage}</span>
        <span>{children}</span>
      </div>
    </div>
  );
};

export default PaymentError;
